import { render, staticRenderFns } from "./SkillEditorDetails.vue?vue&type=template&id=0bb954f8&"
import script from "./SkillEditorDetails.vue?vue&type=script&lang=js&"
export * from "./SkillEditorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports